import { useEffect } from "react";

export function useHorizontalScroll() {
  useEffect(() => {
    // ─── 1. Shift + Scroll ────────────────────────────────────────────────
    function onWheel(e) {
      if (!e.shiftKey) return;

      // إيجاد أقرب عنصر فيه horizontal scroll
      const target = getScrollableParent(e.target, "x");
      if (!target) return;

      e.preventDefault();
      target.scrollBy({ left: e.deltaY, behavior: "auto" });
    }

    // ─── 2. Middle Mouse Button Drag ──────────────────────────────────────
    let isDragging = false;
    let startX = 0;
    let scrollEl = null;
    let startScrollLeft = 0;

    function onMouseDown(e) {
      if (e.button !== 1) return; // فقط الزرار الأوسط

      const target = getScrollableParent(e.target, "x");
      if (!target) return;

      e.preventDefault(); // يمنع auto-scroll cursor الافتراضي للمتصفح

      isDragging = true;
      startX = e.clientX;
      scrollEl = target;
      startScrollLeft = target.scrollLeft;

      document.body.style.cursor = "grabbing";
    }

    function onMouseMove(e) {
      if (!isDragging || !scrollEl) return;
      const dx = e.clientX - startX;
      scrollEl.scrollLeft = startScrollLeft - dx;
    }

    function onMouseUp(e) {
      if (e.button !== 1 && isDragging === false) return;
      isDragging = false;
      scrollEl = null;
      document.body.style.cursor = "";
    }

    // passive: false عشان نقدر نعمل preventDefault على الـ wheel
    window.addEventListener("wheel", onWheel, { passive: false });
    window.addEventListener("mousedown", onMouseDown);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    // لو المستخدم طلع برة النافذة وهو بيعمل drag
    window.addEventListener("mouseleave", onMouseUp);

    return () => {
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("mousedown", onMouseDown);
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
      window.removeEventListener("mouseleave", onMouseUp);
    };
  }, []);
}

// ─── Helper: يلاقي أقرب أب فيه scroll في الاتجاه المطلوب ────────────────────
function getScrollableParent(el, axis) {
  let node = el;
  while (node && node !== document.body) {
    const style = window.getComputedStyle(node);
    const overflow =
      axis === "x"
        ? style.overflowX
        : style.overflowY;

    const isScrollable =
      overflow === "auto" || overflow === "scroll" || overflow === "overlay";

    const hasScroll =
      axis === "x"
        ? node.scrollWidth > node.clientWidth
        : node.scrollHeight > node.clientHeight;

    if (isScrollable && hasScroll) return node;
    node = node.parentElement;
  }

  // fallback: window نفسه لو مافيش عنصر
  return axis === "x" && document.documentElement.scrollWidth > window.innerWidth
    ? document.documentElement
    : null;
}
